import { render, staticRenderFns } from "./WishListHeader.vue?vue&type=template&id=3dd6e920&scoped=true"
import script from "./WishListHeader.vue?vue&type=script&lang=js"
export * from "./WishListHeader.vue?vue&type=script&lang=js"
import style0 from "./WishListHeader.vue?vue&type=style&index=0&id=3dd6e920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd6e920",
  null
  
)

export default component.exports